import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { FieldRadioButton } from '../../components'; // adjust import if needed

import css from './FieldCheckboxGroup.module.css'; // You can reuse FieldCheckboxGroup styles

const FieldRadioGroup = props => {
  const {
    id,
    name,
    label,
    options,
    className,
    rootClassName,
    optionLabelClassName,
    onPackageChange, // custom onChange logic
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <fieldset className={classes}>
      {label ? <legend>{label}</legend> : null}
      <ul className={css.list}>
        {options.map((option, index) => {
          const fieldId = `${id}.${option.key}`;
          return (
            <li key={fieldId} className={css.item}>
              <Field
                name={name}
                type="radio"
                value={String(option.key)}
                render={({ input }) => (
                  <>
                    <FieldRadioButton
                      id={fieldId}
                      label={option.label}
                      value={String(option.key)}
                      {...input}
                      onChange={e => {
                        input.onChange(e); // update value
                        if (option.date && onPackageChange) {
                          const selectedDate = new Date(option.date);
                          const endDate = new Date(selectedDate);
                          endDate.setDate(endDate.getDate() + 1);
                          onPackageChange({
                            startDate: selectedDate,
                            endDate: endDate,
                          });
                        }
                      }}
                    />
                    {option.description && (
                      <div className={css.optionDescription}>{option.description}</div>
                    )}
                    {option.date && (
                      <div className={css.optionDescription}>
                        <b>{option.date}</b>
                      </div>
                    )}
                  </>
                )}
              />
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
};

export default FieldRadioGroup;
